import { render } from "./tab.vue?vue&type=template&id=05caafea&scoped=true&ts=true"
import script from "./tab.vue?vue&type=script&lang=ts"
export * from "./tab.vue?vue&type=script&lang=ts"

import "./tab.vue?vue&type=style&index=0&id=05caafea&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05caafea"]])